import { CartItem } from './app.models';
import { ItineraryState, ItineraryStop, ItineraryStopRef, StopType } from './pages/plan-your-visit-page/models/itinerary.models';

export class UpdateProfileAction {
  static readonly type = '[FMLA] Login';
  constructor(public profile: any) {}
}

export class LogoutAction {
  static readonly type = '[FMLA] Logout';
  constructor() {}
}

export class AddItemToCart {
  static readonly type = '[FMLA] AddItemToCart';
  constructor(public item: CartItem) {}
}

export class RemoveItemFromCart {
  static readonly type = '[FMLA] RemoveItemFromCart';
  constructor(public item: CartItem) {}
}

export class RemoveAllItemsFromCart {
  static readonly type = '[FMLA] RemoveAllItemsFromCart';
  constructor() {}
}

export class UpdateItemInCart {
  static readonly type = '[FMLA] UpdateItemInCart';
  constructor(public item: CartItem, public quantity: number) {}
}

export class UpdateSelectedEventMonth {
  static readonly type = '[FMLA] UpdateSelectedMonth';
  constructor(public month: string) {}
}

export class UpdateSelectedMerchantCategory {
  static readonly type = '[FMLA] UpdateSelectedMerchantCategory';
  constructor(public categoryName: string, public subCategoryName: string) {}
}

export class UpdateSelectedStoreCategory {
  static readonly type = '[FMLA] UpdateSelectedStoreCategory';

  constructor(public categoryName: string) {}
}

export class UpdateSelectedNewsCategory {
  static readonly type = '[FMLA] UpdateSelectedNewsCategory';
  constructor(public categoryId: string) {}
}

export class AddItineraryStop {
  static readonly type = '[FMLA] AddItineraryStop';
  constructor(public stop: ItineraryStopRef) {}
}

export class AddItineraryStops {
  static readonly type = '[FMLA] AddItineraryStops';
  constructor(public stops: ItineraryStopRef[]) {}
}

export class RemoveItineraryStop {
  static readonly type = '[FMLA] RemoveItineraryStop';
  constructor(public stop: ItineraryStopRef) {}
}

export class RemoveItineraryStops {
  static readonly type = '[FMLA] RemoveItineraryStops';
  constructor(public stops: ItineraryStopRef[]) {}
}

export class ToggleItineraryStop {
  static readonly type = '[FMLA] ToggleItineraryStop';
  constructor(public stop: ItineraryStopRef) {}
}

export class ReorderItineraryStops {
  static readonly type = '[FMLA] ReorderItineraryStops';
  constructor(public stops: ItineraryStop[]) {}
}

export class RenameItinerary {
  static readonly type = '[FMLA] RenameItinerary';
  constructor(public name: string) {}
}

export class ClearItinerary {
  static readonly type = '[FMLA] ClearItinerary';
  constructor() {}
}

export class LoadItinerary {
  static readonly type = '[FMLA] LoadItinerary';
  constructor(public state: Partial<ItineraryState>) {}
}

export class StartFromPersonaList {
  static readonly type = '[FMLA] StartFromPersonaList';
  constructor(public listId: string, public stops: ItineraryStopRef[]) {}
}

export class CreateItinerary {
  static readonly type = '[FMLA] CreateItinerary';
  constructor(public name?: string, public setAsCurrent: boolean = true) {}
}

export class SelectItinerary {
  static readonly type = '[FMLA] SelectItinerary';
  constructor(public id: string | null) {}
}

export class DeleteItinerary {
  static readonly type = '[FMLA] DeleteItinerary';
  constructor(public id: string) {}
}

export class SaveItinerary {
  static readonly type = '[FMLA] SaveItinerary';
  constructor(public name?: string) {}
}

export class FlashItinerary {
  static readonly type = '[FMLA] FlashItinerary';
  constructor(public id: string | null) {}
}
